import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';

export const Button = styled.button`
  width: 150px;
  transition: all 0.5s ease-in-out;
  background-color: #FFA500;
  border: none;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  font-family: 'Nunito', sans-serif;
  height: 40px;
  letter-spacing: 1px;
  margin: 10px ;
  &:hover {
    background-color: #FFA555;
    border-color: #fff;
  }
  &:disabled {
    background-color: grey;
    border-color: #fff;
  }
}
`;

const styles = {
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  card: {
    width: '64%',
    height: '60%',
  },
  container: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
  },
  questionContainer: {
    width: '100%',
    padding: '10px',
  },
  question: {
    border: '1px solid #FFA500',
    padding: '5px',
    fontSize: '20px',
    fontFamily: 'Nunito',
    fontWeight: 'bold',
    borderRadius: '10px',
    textAlign: 'center',
    margin: '20px',
  },
};
export const useStyles = makeStyles(styles);
